export enum EnumApiCore {
  /** 提问 */
  homeworkQA = '/core/api/qa',
  bookList = '/core/api/book/shell/list',
  bookAuth = '/core/api/book/shell/auth/{bookId}'
}
